import { render, staticRenderFns } from "./UserProfileCongratulationsMessage.vue?vue&type=template&id=51f49c44"
import script from "./UserProfileCongratulationsMessage.vue?vue&type=script&lang=js"
export * from "./UserProfileCongratulationsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports